import {ApiRequestEnum} from '../enums/api-request.enum';
import {ApiService} from './api.service';
import {BehaviorSubject, Observable, throwError} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LocationService {
	private addressChanged$: BehaviorSubject<ICurrentAddress>;

	constructor(private http: HttpClient, private apiService: ApiService) {
		this.addressChanged$ = new BehaviorSubject({} as ICurrentAddress);
	}

	set userDefinedLocation(location: Object) {
		localStorage.setItem('user-location', JSON.stringify(location));
	}

	get userDefinedLocation(): Object {
		return JSON.parse(<string>localStorage.getItem('user-location'));
	}

	public hasUserDefinedLocation(): boolean {
		return !!(this.userDefinedLocation);
	}

	GetShopCountByLocation(param: { ip: string }) {
		return this.apiService.get(ApiRequestEnum.AGGRIGRATE_BY_LOCATION.replace('{{ipAddress}}', param.ip));
	}

	MarketplaceAnalytics() {
		return this.apiService.get(
			ApiRequestEnum.AGGRIGRATE_MARKETPLACE_ANALYTICS
		);
	}

	LocationByLatLong(param: { latitude: number, longitude: number }) {
		return this.apiService.post(
			ApiRequestEnum.LOCATION_BY_LAT_LONG,
			param
		);
	}

	getClientIp() {
		return this.http.get('https://api.ipify.org/?format=json').pipe(
			// switchMap((res: any) => this.http.get('https://ipwho.is/' + res.ip)),
			map((res: any) => {
				return res;
				/*return {
					city: res.city,
					name: `${res.city}, ${res.region}`,
				};*/
			}),
			catchError((error) => throwError(error))
		);
	}

	getPosition(): Promise<any> {
		return new Promise((resolve, reject) => {
			navigator.geolocation.getCurrentPosition(
				(resp) => {
					resolve({lng: resp.coords.longitude, lat: resp.coords.latitude});
				},
				(err) => {
					reject(err);
				}
			);
		});
	}

	/*getArea() {
		return this.apiService.get(ApiRequestEnum.AREA);
	}*/

	getCurrentAddress$() {
		return this.addressChanged$.asObservable();
	}

	emitCurrentAddress(address: ICurrentAddress) {
		if (!this.addressChanged$) {
			this.addressChanged$ = new BehaviorSubject(address);
		} else {
			this.addressChanged$.next(address);
		}
	}
}

export interface ICurrentAddress {
	name: string;
	city: string;
}
